import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M21.907 6.24604C21.907 5.92504 21.648 5.66504 21.327 5.66504H2.58C2.26 5.66504 2 5.92604 2 6.24604C2 6.56604 2.26 6.82704 2.58 6.82704H21.327C21.648 6.82704 21.907 6.56704 21.907 6.24604Z"
      fill="currentColor"
    />
    <path
      d="M21.11 7.80701C20.523 7.56701 19.845 7.73201 19.341 8.24201L14.794 12.809C14.35 13.256 13.578 13.255 13.134 12.809L8.65905 8.31601C8.55305 8.18201 8.39005 8.09701 8.20605 8.09701H4.57805C4.25805 8.09701 3.99805 8.35701 3.99805 8.67801C3.99805 8.99901 4.25805 9.25901 4.57805 9.25901H7.96005L12.312 13.629C13.194 14.515 14.733 14.516 15.615 13.629L20.162 9.06101C20.364 8.85701 20.56 8.83801 20.667 8.88101C20.816 8.94301 20.839 9.13501 20.839 9.24501V15.993C20.839 16.643 20.312 17.173 19.665 17.173H8.29405C7.64605 17.173 7.11905 16.644 7.11905 15.993V10.988C7.11905 10.952 7.11305 10.904 7.10705 10.869C7.05605 10.594 6.81605 10.394 6.53705 10.394H6.06405C5.74405 10.394 5.48405 10.654 5.48405 10.975C5.48405 11.26 5.68805 11.496 5.95805 11.546V15.993C5.95805 17.284 7.00605 18.335 8.29305 18.335H19.665C20.952 18.335 21.999 17.284 21.999 15.993V9.24501C22 8.58501 21.659 8.03401 21.11 7.80701Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'SendMessage');

export default Icon;
